import React, { PureComponent } from "react";
import { connect } from "react-redux";
import { PropTypes } from "prop-types";
import { Button } from "semantic-ui-react";
import { Formik, Form, Field } from "formik";

import * as Yup from "yup";
import * as Schemas from "../forms/validationSchemas.js";

import ValidationMessage from "../forms/messages/ValidationMessage.jsx";
import FormikSemanticInput from "../forms/formik/FormikSemanticInput.jsx";

import { selectLatestViolationErrors } from "../../state/reducers/api/apiSelectors.js";
import { selectCopy } from "../../state/reducers/locale/copySelector.js";

class UserDetailsRequestForm extends PureComponent {
  static propTypes = {
    isFetching: PropTypes.bool.isRequired,
    onSubmit: PropTypes.func.isRequired,
    copyKey: PropTypes.string.isRequired,
    copy: PropTypes.func.isRequired
  };

  static defaultProps = {
    isFetching: false
  };

  constructor(props) {
    super(props);

    this.state = {
      showMessages: false
    };

    this.initialValues = {
      email: ""
    };
  }

  // -- VALIDATION -- //

  validationSchema = function () {
    const messages = this.props.copy("forms.validation_requirements");

    return Yup.object().shape({
      email: Schemas.emailSchema("Email", messages, true)
    });
  };

  // -- HANDLERS -- //

  onSubmit = () => {
    this.setState({ showMessages: true });
  };

  // only triggered whenever the submit button is clicked and the form is valid
  onFormikSubmit = values => {
    this.props.onSubmit(values);
  };

  // -- RENDER -- //

  // handling this outside of Formik as the message should be shown as soon as submit has been clicked
  // not just on successfull Formik submission, or on failed validation check.
  renderMessage = formikProps => {
    const valid =
      formikProps.isValid && !this.props.violationErrors ? true : false;

    if (this.state.showMessages !== true || valid) return null;

    return <ValidationMessage className="mid-panel-message" valid={valid} />;
  };

  render() {
    const { isFetching, violationErrors, copyKey, copy } = this.props;

    return (
      <Formik
        initialValues={this.initialValues} // required by semantic-ui react
        validateOnMount={true}
        validationSchema={this.validationSchema()}
        onSubmit={this.onFormikSubmit}
      >
        {formikProps => {
          return (
            <Form className="ui form">
              {this.renderMessage(formikProps)}

              <p>{copy(`${copyKey}.body`)}</p>
              <Field
                name="email"
                placeholder={copy(`${copyKey}.email_input.placeholder`)}
                required={true}
                fluid
                disabled={isFetching}
                apiErrors={violationErrors}
                component={FormikSemanticInput}
              />
              <Button
                loading={isFetching}
                type="submit"
                primary
                fluid
                size="large"
                onClick={this.onSubmit}
              >
                {copy(`${copyKey}.send_cta`)}
              </Button>
            </Form>
          );
        }}
      </Formik>
    );
  }
}

const mapStateToProps = state => ({
  violationErrors: selectLatestViolationErrors(state),
  copy: selectCopy(state)
});

export default connect(mapStateToProps)(UserDetailsRequestForm);
